// @ts-nocheck
/**
 * API wrappers for mapping session persistence.
 */

const BASE = import.meta.env.VITE_BACKEND_BASE_URL;
const API_KEY = import.meta.env.VITE_API_KEY;

const defaultHeaders = {
  'Content-Type': 'application/json',
  'x-api-key': API_KEY,
};

export async function saveSession(sessionData) {
  const res = await fetch(`${BASE}/sessions/save`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify(sessionData),
  });
  if (!res.ok) throw new Error(`Save session failed: ${res.status}`);
  return res.json();
}

export async function listSessions(featureKey = 'comparative', limit = 50, offset = 0) {
  const params = new URLSearchParams({ limit, offset });
  if (featureKey) params.set('feature_key', featureKey);
  const res = await fetch(`${BASE}/sessions/list?${params}`, {
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`List sessions failed: ${res.status}`);
  return res.json();
}

export async function getSession(sessionId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}`, {
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`Get session failed: ${res.status}`);
  return res.json();
}

export async function renameSession(sessionId, name) {
  const res = await fetch(`${BASE}/sessions/${sessionId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify({ name }),
  });
  if (!res.ok) throw new Error(`Rename session failed: ${res.status}`);
  return res.json();
}

export async function pinSession(sessionId, pinned = true, qoeReport = null) {
  const body = { pinned };
  if (qoeReport !== null && qoeReport !== undefined) body.qoe_report = qoeReport;
  const res = await fetch(`${BASE}/sessions/${sessionId}/pin`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Pin session failed: ${res.status}`);
  return res.json();
}

export async function updateSessionResults(sessionId, payload) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/update-results`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Update session results failed: ${res.status}`);
  return res.json();
}

export async function updateSessionProcessingConfig(sessionId, processingConfig) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/update-processing-config`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify({ processing_config: processingConfig }),
  });
  if (!res.ok) throw new Error(`Update processing config failed: ${res.status}`);
  return res.json();
}

export async function attachQoeReport(sessionId, qoeReport) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/attach-qoe`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify({ qoe_report: qoeReport }),
  });
  if (!res.ok) throw new Error(`Attach QoE failed: ${res.status}`);
  return res.json();
}

export async function unpinSession(sessionId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/unpin`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error(`Unpin session failed: ${res.status}`);
  return res.json();
}

/** Tenant members + session-share CRUD (drives the Share modal). */
export async function listTenantMembers() {
  const res = await fetch(`${BASE}/sessions/tenant-members`, {
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`List tenant members failed: ${res.status}`);
  return res.json();
}

export async function listSessionShares(sessionId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/shares`, {
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`List shares failed: ${res.status}`);
  return res.json();
}

export async function shareSession(sessionId, { user_ids, user_emails }) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/shares`, {
    method: 'POST',
    credentials: 'include',
    headers: defaultHeaders,
    body: JSON.stringify({ user_ids, user_emails }),
  });
  if (!res.ok) throw new Error(`Share session failed: ${res.status}`);
  return res.json();
}

export async function revokeSessionShare(sessionId, userId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/shares/${userId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`Revoke share failed: ${res.status}`);
  return res.json();
}

export async function deleteSession(sessionId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) throw new Error(`Delete session failed: ${res.status}`);
  return res.json();
}
